


















import { computed, defineComponent, onMounted, watch } from '@vue/composition-api';
import { initEnvSettings, EnvSettings } from '@/admin/envSettings';
import FcSideBar from '@/components/SideBar.vue';
import FcNotification from '@/components/Notification.vue';
import consoleMenu from '@/composition/consoleMenu';
import core from '@/admin/core';
import myAttributes from '@/composition/myAttributes';
import FcRoleLoading from '@/components/FcRoleLoading.vue';
import FcConfirm from '@/components/FcConfirm.vue';

export default defineComponent({
  name: 'App',
  components: {
    FcSideBar,
    FcNotification,
    FcRoleLoading,
    FcConfirm,
  },
  setup(_, context) {
    // ロールとコンソールメニューの取得
    const isLoadingMyRole = computed(() => myAttributes.isLoading);
    const myRoleSettings = computed(() => myAttributes.myRoleSettings);
    const path = computed(() => context.root.$route.path);
    const isPreview = computed(() => path.value.includes('/preview'));

    const startOnboarding = (envSettings: EnvSettings) => {
      const startFaveOnboarding = (window as { startFaveOnboarding?: (queryParams: Record<string, string>) => void })
        .startFaveOnboarding;
      startFaveOnboarding?.({
        user_id: myAttributes.username,
        user_name: myAttributes.name,
        user_group_name: envSettings.siteName || '',
      });
    };

    const init = async () => {
      consoleMenu.fetchConsoleMenu();
      const [, envSettings] = await Promise.all([myAttributes.getMyRole(), initEnvSettings()]);
      startOnboarding(envSettings);
    };

    onMounted(async () => {
      if (core.isAuthenticated) {
        await init();
      }
    });

    watch(
      () => core.isAuthenticated,
      async () => {
        if (core.isAuthenticated) {
          await init();
        }
      }
    );

    return {
      isAuthenticated: core.isAuthenticated,
      isLoadingMyRole,
      myRoleSettings,
      isPreview,
    };
  },
});
